import IonIcon from '@reacticons/ionicons'
import cn from 'classnames'
import { useRouter } from 'next/router'
import React, { ChangeEvent, memo, useEffect, useState } from 'react'
import { useGetTopicsForHeaderQuery } from 'src/graphql/generated/hooks'
import { useUpdateQueryParams } from 'src/hooks/useUpdateQueryParams'

export interface SearchFieldProps {
  fontSize?: number
  height?: number
  className?: string
}

/**
 * Primary UI component for user interaction
 */
export const SearchField: React.FC<SearchFieldProps> = memo(({ className = '', ...props }) => {
  const { data } = useGetTopicsForHeaderQuery({ fetchPolicy: 'cache-first' })
  const router = useRouter()
  const { updateQueryParams } = useUpdateQueryParams()
  const [value, SetValue] = useState(router.query.keyword || '')

  useEffect(() => {
    if (router.query.keyword) SetValue(router.query.keyword)
    else SetValue('')
  }, [router.query])

  const onTextChanged = (e: ChangeEvent<HTMLInputElement>) => {
    const target: HTMLInputElement = e.target as HTMLInputElement
    SetValue(target.value)
  }

  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      if (value !== '') {
        const searchKeyword = (value as string).trim()
        SetValue(searchKeyword)
        updateQuery(searchKeyword)
      } else {
        updateQuery('')
      }
    }
  }

  const updateQuery = (keyword = '') => {
    const subTopicFound = data?.topics?.data.some((item) =>
      item.attributes?.subTopics?.data.some(
        (sub) => sub.attributes?.name.toLowerCase() === decodeURIComponent(keyword as string).toLowerCase(),
      ),
    )
    const topicFound = data?.topics?.data.some(
      (item) => item.attributes?.name.toLowerCase() === decodeURIComponent(keyword as string).toLowerCase(),
    )
    if (keyword != '' && data && router.asPath.includes('/search') && (topicFound || subTopicFound)) {
      if (
        data?.topics?.data.some(
          (item) => item.attributes?.name.toLowerCase() === decodeURIComponent(keyword as string).toLowerCase(),
        )
      ) {
        const productType: string[] = []
        data?.topics?.data
          .filter((item) => item.attributes?.name.toLowerCase() === decodeURIComponent(keyword as string).toLowerCase())
          .map((item) => {
            item.attributes?.subTopics?.data.map((subTopic) => {
              productType.push((parseInt(item.id!) * 10000 + parseInt(subTopic.id!)).toString())
            })
          })

        updateQueryParams({
          keyword: keyword,
          productType: productType.join(','),
        })
      } else {
        data?.topics?.data.map((item) => {
          item.attributes?.subTopics?.data
            .filter((sub) => sub.attributes?.name.toLowerCase() === decodeURIComponent(keyword as string).toLowerCase())
            .map((sub) => {
              updateQueryParams({
                keyword: keyword,
                productType: (parseInt(item.id!) * 10000 + parseInt(sub.id!)).toString(),
              })
            })
        })
      }
    } else {
      updateQueryParams({
        keyword: keyword ? keyword : undefined,
        page: undefined,
      })
    }
  }

  return (
    <div
      className={cn(
        'flex',
        'flex-row items-center',
        'border-mist border-solid border rounded-[20px] min-h-[42px] bg-white pl-[14px]',
        className,
      )}
      {...props}
    >
      <IonIcon name="search" />
      <input
        type="text"
        className="focus:outline-none w-full font-primary font-regular text-textdark opacity-70 text-[14px] mr-[14px] ml-[14px] leading-[42px]"
        placeholder="Search within"
        onChange={onTextChanged}
        onKeyPress={handleKeyPress}
        value={value}
      />
    </div>
  )
})
